/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type BuyerAssurance_item = {|
  +isArt: ?boolean;
  +isFurniture: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerAssurance_item",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isArt",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isFurniture",
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/BuyerAssurance/__generated__/BuyerAssurance_item.graphql.js